class CheckUser {

    constructor() {
        this.emailInput = $("#username");
        this.passwordInput = $("#password");
        this.emptyUsernameMessage = $("#emptyUsernameMessage");
        this.emptyPasswordMessage = $("#emptyPasswordMessage");
        this.blockingDateMessage = $("#blockingDateMessage");
    }

    checkInputs() {
        this.checkEmailInput();
        this.checkPasswordInput();
        if(this.checkEmailInput() === false || this.checkPasswordInput() === false) {
            return false;
        } else {
            return true;
        }
    }

    checkEmailInput() {
        if(this.emailInput.val() === "") {
            this.setEmptyUsernameMessage("To pole nie może pozostać bez wartości");
            return false;
        } else {
            this.setEmptyUsernameMessage("");
            return true;
        }
    }

    setEmptyUsernameMessage(message) {
        this.emptyUsernameMessage.text(message);
    }

    checkPasswordInput() {
        if(this.passwordInput.val() === "") {
            this.setEmptyPasswordMessage("To pole nie może pozostać bez wartości");
            return false;
        } else {
            this.setEmptyPasswordMessage("");
            return true;
        }
    }

    setEmptyPasswordMessage(message) {
        this.emptyPasswordMessage.text(message);
    }

    setBlockingDateMessage(message) {
        this.blockingDateMessage.text(message);
    }
}

export default CheckUser;


// WEBPACK FOOTER //
// ./assets/js/utils/check-user.js